export default defineNuxtPlugin(() => {
    const { hash } = location
    const router = useRouter()
  
    // If vue-router broke hash on init, restore it back.
    // See https://github.com/deptyped/vue-telegram/issues/18
    let needFixHash = router.currentRoute.value.hash !== hash
    if (needFixHash) {
      router.afterEach(() => {
        if (needFixHash) {
          // Restore launch data without a fragment navigation that can leave Telegram's loader running.
          history.replaceState(history.state, '', `${location.pathname}${location.search}${hash}`)
          needFixHash = false
        }
      })
    }
  })
